/*
 * Dots spinner
 */
.dots {
    position: relative;
    user-select: none;
}

.dots > svg {
    transform-origin: center center;
    position: absolute;
    top: 0px;
    left: 0px;
    width: 100%;
    height: 100%;
    transform: translateZ(0px);
    animation: dots-animation 1s linear infinite;
}

.dots > svg:nth-child(1) {
    left: 32%;
    animation-delay: 0ms;
    animation-duration: 750ms;
}

.dots > svg:nth-child(2) {
    left: 0%;
    animation-delay: -110ms;
    animation-duration: 750ms;
}

.dots > svg:nth-child(3) {
    left: -32%;
    animation-delay: -220ms;
    animation-duration: 750ms;
}

.dots > svg > circle {
    transform-origin: 0px 0px;
    transform-box: view-box;
    stroke-width: 0px;
    fill: currentcolor;
}

@keyframes dots-animation {
    0% {
        transform: scale(1, 1);
        opacity: 0.9;
    }

    50% {
        transform: scale(0.4, 0.4);
        opacity: 0.3;
    }

    100% {
        transform: scale(1, 1);
        opacity: 0.9;
    }
}
